/**
 * Review PropTypes
 *
 * PropType definitions for product reviews and ratings.
 *
 * @module propTypes/review
 */

import PropTypes from "prop-types";

/**
 * Review shape
 * Represents a single customer review
 *
 * @property {string} name - Reviewer's name
 * @property {number} stars - Star rating (1-5)
 * @property {string} message - Review text content
 */
export const reviewShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  stars: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
});

/**
 * Review statistics shape
 * Aggregated review data for a product
 *
 * @property {number} total - Total number of reviews
 * @property {number} average - Average rating score
 */
export const reviewStatsShape = PropTypes.shape({
  total: PropTypes.number,
  average: PropTypes.number,
});
